import { render } from "./Profile-Others.vue?vue&type=template&id=affe45a8"
import script from "./Profile-Others.vue?vue&type=script&lang=js"
export * from "./Profile-Others.vue?vue&type=script&lang=js"

import "./Profile-Others.vue?vue&type=style&index=0&id=affe45a8&lang=less"

import exportComponent from "C:\\Users\\sander\\IdeaProjects\\matchmaking\\fbm-matchmaking\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__